module.exports = __webpack_public_path__ + "img/star-map_backgrounds-white.15c3992.webp";